import React from 'react';
import InvestorEarningsCalculatorSC from './investor-earnings-calculator.styled';
import InfoBanner from '../../components/info-banner';
import ContentWrap from '../../components/content-wrap';
import { BodyText } from '../../components/typography';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import dlt from '../../utils/default-lang';
import Button from '../../components/ui/button';
import PredictionChart from '../../components/charts/prediction-chart';
import { useHistory } from 'react-router-dom';
import { ROUTE_DASHBOARD } from '../../constants';

const InvestorEarningsCalculator = () => {
  const history = useHistory();

  return (
    <InvestorEarningsCalculatorSC>
      <InfoBanner contentClassName="wider-container">
        <PredictionChart />
      </InfoBanner>
      <ContentWrap>
        <div className="content-wrapper">
          <BodyText className="bolder">
            <FormattedHTMLMessage
              id="investor_prediction_unfinished_registration_title"
              defaultMessage={dlt['investor_prediction_unfinished_registration_title']}
            />
          </BodyText>
          <div className="button-wrapper">
            <Button
              className="pulsing"
              type="PRIMARY"
              size="BIG"
              onClick={() => history.push(ROUTE_DASHBOARD)}
            >
              <FormattedMessage
                id="investor_prediction_unfinished_registration_button"
                defaultMessage="investor_prediction_unfinished_registration_button"
              />
            </Button>
          </div>
        </div>
      </ContentWrap>
    </InvestorEarningsCalculatorSC>
  );
};

export default InvestorEarningsCalculator;
